export const EMERGENCY_ACCESS_REQUEST_REQUEST = 'EMERGENCY_ACCESS_REQUEST_REQUEST';
export const EMERGENCY_ACCESS_REQUEST_SUCCESS = 'EMERGENCY_ACCESS_REQUEST_SUCCESS';
export const EMERGENCY_ACCESS_REQUEST_FAIL = 'EMERGENCY_ACCESS_REQUEST_FAIL';
export const EMERGENCY_ACCESS_REQUEST_RESET = 'EMERGENCY_ACCESS_REQUEST_RESET';

export const EMERGENCY_ACCESS_VERIFY_REQUEST = 'EMERGENCY_ACCESS_VERIFY_REQUEST';
export const EMERGENCY_ACCESS_VERIFY_SUCCESS = 'EMERGENCY_ACCESS_VERIFY_SUCCESS';
export const EMERGENCY_ACCESS_VERIFY_FAIL = 'EMERGENCY_ACCESS_VERIFY_FAIL';

export const EMERGENCY_ACCESS_PATIENT_REQUEST = 'EMERGENCY_ACCESS_PATIENT_REQUEST';
export const EMERGENCY_ACCESS_PATIENT_SUCCESS = 'EMERGENCY_ACCESS_PATIENT_SUCCESS';
export const EMERGENCY_ACCESS_PATIENT_FAIL = 'EMERGENCY_ACCESS_PATIENT_FAIL';

export const EMERGENCY_ACCESS_HISTORY_REQUEST = 'EMERGENCY_ACCESS_HISTORY_REQUEST';
export const EMERGENCY_ACCESS_HISTORY_SUCCESS = 'EMERGENCY_ACCESS_HISTORY_SUCCESS';
export const EMERGENCY_ACCESS_HISTORY_FAIL = 'EMERGENCY_ACCESS_HISTORY_FAIL';

export const EMERGENCY_ACCESS_REVOKE_REQUEST = 'EMERGENCY_ACCESS_REVOKE_REQUEST';
export const EMERGENCY_ACCESS_REVOKE_SUCCESS = 'EMERGENCY_ACCESS_REVOKE_SUCCESS';
export const EMERGENCY_ACCESS_REVOKE_FAIL = 'EMERGENCY_ACCESS_REVOKE_FAIL';



